import type { FC } from 'react';
import CareerAccordion from 'blocks/CareerListSection/components/CareerAccordion';
import type { CareerType, CountryCodeType } from 'types/types';
import { Body, Heading } from 'components/text';
import {
  current_open_roles,
  join_a_team_redefining_luxury,
} from 'data/translationKeys';
import AccordionList from 'components/accordion-list';
import useLocalised from 'customHooks/useLocalised/useLocalised';

interface ICareerListSection {
  careers: CareerType[];
  countryCodes: CountryCodeType[];
}

const CareerListSection: FC<ICareerListSection> = ({
  careers,
  countryCodes,
}) => {
  const current_open_roles_title = useLocalised(current_open_roles);
  const join_a_team_redefining_luxury_description = useLocalised(
    join_a_team_redefining_luxury
  );

  return (
    <div className="career-list-container">
      <div className="career-list-container__heading">
        <Heading as="h1" className="career-list-container__title">
          {current_open_roles_title}
        </Heading>
        <Body>{join_a_team_redefining_luxury_description}</Body>
      </div>
      <div className="career-list">
        <AccordionList<CareerType>
          items={careers}
          getId={career => String(career.id)}
          getTitle={career => career.name}
          getContent={career => [career]}
          getChipLabel={career => career.location}
          withLabel
          renderContent={career => {
            return (
              <CareerAccordion
                key={career.id}
                career={career}
                countryCodes={countryCodes}
              />
            );
          }}
        />
      </div>
    </div>
  );
};

export default CareerListSection;
